import React, { FunctionComponent } from 'react';

export interface TextareaProps {
    label?: string;
    name: string;
    defaultValue?: any;
    id: string;
    placeholder?: string;
    register: any;
    validation?: any;
    hasError?: any;
    helperLabel?: string;
    value?: string;
}

export const Textarea: FunctionComponent<TextareaProps> = ({
    label,
    name,
    defaultValue,
    id,
    placeholder,
    register,
    validation,
    hasError,
    helperLabel,
    value,
}) => {
    const registerProps = register(name, validation ? validation : {});
    return (
        <div className={`c-textarea ${hasError ? 'textarea--has-error' : ''}`}>
            {label && (
                <label className="textarea__label" htmlFor={id}>
                    {label}
                </label>
            )}

            <textarea
                className="textarea__input"
                id={id}
                placeholder={placeholder}
                defaultValue={defaultValue}
                {...registerProps}
                onChange={(e) => {
                    // validation && validation.overwriteOnChange ? validation.overwriteOnChange
                    if (validation && validation.overwriteOnChange) {
                        registerProps.onChange(e);
                        validation.overwriteOnChange(e);
                    } else {
                        registerProps.onChange(e);
                    }
                }}
                onKeyUp={validation && validation.onKeyUp}
                onFocus={validation && validation.onFocus}
                autoComplete="off"
                value={value}
            />
            {helperLabel && <span className="input__helper-label">{helperLabel}</span>}
        </div>
    );
};
